import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
    modals: [],
    activeModalTitle: '',
    activeBreadcrumbName: undefined,
    savedPosition: {
        left: 0,
        top: 0,
    },
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
